import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duplicateCount',
  pure: true,
})
export class DuplicateCountPipe implements PipeTransform {
  /**
   * Counts total items that belong to duplicate groups for a given property.
   * Items marked with the ignoreFlagKey (defaults to ignore_as_duplicate) are skipped.
   */
  transform<T extends Record<string, any>>(
    items: T[] | null | undefined,
    propertyKey: string,
    ignoreFlagKey: string | null = 'ignore_as_duplicate'
  ): number {
    if (!Array.isArray(items) || !propertyKey) {
      return 0;
    }

    const counts = new Map<string | number, number>();

    for (const item of items) {
      if (!item) {
        continue;
      }

      if (ignoreFlagKey && item[ignoreFlagKey]) {
        continue;
      }

      const propertyValue = item[propertyKey];

      if (propertyValue === undefined || propertyValue === null || propertyValue === '') {
        continue;
      }

      const normalizedValue =
        typeof propertyValue === 'string' ? propertyValue.trim().toLowerCase() : (propertyValue as string | number);

      if (!normalizedValue && normalizedValue !== 0) {
        continue;
      }

      counts.set(normalizedValue, (counts.get(normalizedValue) || 0) + 1);
    }

    let duplicateTotal = 0;
    counts.forEach((count) => {
      if (count > 1) {
        duplicateTotal += count;
      }
    });

    return duplicateTotal;
  }
}

